var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"sliderEmptyState":"OSVud"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .OSVud{height:100%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:700}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

